import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { FilterService } from "../../../services/filter.service";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Filter } from "../../../model/filters/filter";
import { BehaviorSubject } from "rxjs";
import { Messages } from "../../../model/messages";
import { AuthService } from "../../../auth.service";
import { MatchAll } from "../../../model/filters/match-all";
import { TicketService } from "../../../services/ticket.service";
import { ActionButtonSubmit } from "../../../model/action-button-submit";
function hasFilters(f: Filter): f is MatchAll {
  return (f as MatchAll).filters !== undefined;
}
@Component({
  selector: "header-filters",
  templateUrl: "./header-filters.component.html",
  styleUrls: ["./header-filters.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderFiltersComponent implements OnInit {
  selectedFilters: Filter[] = [];
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);

  constructor(
    private router: Router,
    private nav: NavigationHelper,
    private filterService: FilterService,
    private auth: AuthService,
    private ticketService: TicketService
  ) {}

  ngOnInit(): void {
    this.filterService.filterObservable.subscribe((filter) => {
      const received = filter as MatchAll;
      if (received && received.filters) {
        this.selectedFilters = received.filters;
      }
    });
  }
  search(action: ActionButtonSubmit): void {
    const token = this.auth.token;

    if (this.selectedFilters.length === 0) {
      this.ticketService.filterService.setStandardFilter();
    }

    this.ticketService.search(token).subscribe((messages) => {
      this.messages.next(messages);

      if (messages.hasAnyMessages) {
        action.result(false);
      } else {
        action.result(true);
        const url = "tickets/-1/result/page/1";
        this.router.navigate([url]);
      }
    });

    localStorage.removeItem("lastTicketPage");
  }

  goToFilterPalette(): void {
    this.router.navigate(["/tickets/-1/filter"]).then((success) => {
      if (success) {
        this.filterService.triggerFilter();
      }
      this.nav.freshNavigation;
    });
  }

  removeFilter(filter: any): void {
    this.filterService.removeFilter(filter);
    this.clearLocalStorageFilters();
  }
  clearLocalStorageFilters(): void {
    const keysToRemove = [
      "selectedUserId",
      "editingUserIndex",
      "registeredUserIds",
      "selectedPriorityId",
      "priorityIds",
      "editingPriorityIndex",
      "selectedId",
      "editingIdIndex",
      "selectedTitleTerm",
      "editingTitleIndex",
      "selectedAssignedUserId",
      "editingAssignedIndex",
      "selectedDepartmentId",
      "departmentIds",
      "editingDepartmentIndex",
      "selectedBranchId",
      "branchIds",
      "editingBranchIndex",
      "selectedStatusId",
      "statusIds",
      "assignedUserIds",
      "idList",
      "titleList",
      "editingStatusIndex",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  }
  clearAllFilters(): void {
    this.selectedFilters = [];
    this.filterService.clearAllFilters();
    this.clearLocalStorageFilters();
    localStorage.removeItem("lastTicketPage");
  }
  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
}
